import "cookieconsent";
import Vue from "vue";
import Vuex from "vuex";
import BootstrapVue from "bootstrap-vue";
import { VLazyImagePlugin } from "v-lazy-image";
import VueCarousel from "vue-carousel";
import { FontAwesomeIcon, FontAwesomeLayers } from "@fortawesome/vue-fontawesome";
import { config } from "@fortawesome/fontawesome-svg-core";
import vClickOutside from "v-click-outside";
import Ecommerce from "spiritweb.packages.ecommerce";
import { createUniqIdsMixin } from "vue-uniq-ids/dist/vue-uniq-ids.min";
import VueScrollTo from "vue-scrollto";
import WebAccount from "spiritweb.packages.web-account";
import Cookie from "~/Scripts/modules/cookie";
import store from "~/Scripts/store";

config.autoReplaceSvg = false;
config.observeMutations = false;

Vue.use( Vuex );
Vue.use( BootstrapVue );
Vue.use( VLazyImagePlugin );
Vue.use( VueCarousel );
Vue.use( vClickOutside );
Vue.use( WebAccount, { store } );
Vue.use( Ecommerce, {
  sentry: { dsn: "" },
} );
Vue.use( VueScrollTo );

Vue.component( "FontAwesomeIcon", FontAwesomeIcon );
Vue.component( "FontAwesomeLayers", FontAwesomeLayers );

const uniqIdsMixin = createUniqIdsMixin();
Vue.mixin( uniqIdsMixin );

const environment = document.querySelector( "meta[name=\"environment\"]" ).getAttribute( "content" );
Vue.prototype.$environment = environment;

const version = document.querySelector( "meta[name=\"version\"]" ).getAttribute( "content" );
Vue.prototype.$version = version;

const packageString = document.querySelector( "meta[name=\"package\"]" ).getAttribute( "content" );
Vue.prototype.$package = packageString;

const evdt = document.querySelector( "meta[name=\"evdt\"]" ).getAttribute( "content" ) === "true";
if ( evdt ) {
  Vue.config.devtools = true;
}

const csrfToken = document.querySelector( "meta[name=\"csrf-token\"]" ).getAttribute( "content" );
Vue.prototype.$csrfToken = csrfToken;

const cookiePolicyUrl = document.getElementById( "cookie-policy-url" ).href;

document.addEventListener( "DOMContentLoaded", () => {
  window.cookieconsent.initialise( {
    position: "top",
    static: true,
    content: {
      message: `We use cookies on our website to enable some essential functions for you in
        accordance with our <a href="${cookiePolicyUrl}">cookie policy</a>. We'd also like your
        permission to store cookies to help us understand how visitors are using our website
        so we can improve the experience for them.`,
      href: cookiePolicyUrl,
    },
    elements: {
      deny: "<a aria-label=\"No thanks. Deny cookies\" role=\"button\" tabIndex=\"0\" class=\"cc-btn cc-deny\">No thanks</a>",
      allow: "<a aria-label=\"That's ok. Allow cookies\" role=\"button\" tabindex=\"0\" class=\"cc-btn cc-allow\">That's ok</a>",
    },
    showLink: false,
    type: "opt-in",
    compliance: {
      "opt-in": "<div class=\"cc-compliance cc-highlight\">{{deny}}{{allow}}</div>",
    },
    onStatusChange () {
      const didConsent = this.hasConsented();
      if ( didConsent ) {
        Cookie.acceptCookies();
      }
      if ( !didConsent ) {
        Cookie.denyCookies();
      }
    },
    onRevokeChoice () {
      const { type } = this.options;
      if ( type === "opt-in" ) {
        Cookie.acceptCookies();
      }
      if ( type === "opt-out" ) {
        Cookie.denyCookies();
      }
    },
  } );
} );
